<template>
  <div
    class="m-grid m-grid--hor m-grid--root m-page"
    style="height: 100%"
  >
    <div
      id="m_login"
      class="m-grid__item m-grid__item--fluid m-grid m-grid--ver-desktop m-grid--desktop m-grid--tablet-and-mobile m-grid--hor-tablet-and-mobile m-login m-login--1 m-login--signin"
    >
      <div
        class=" b m-grid__item m-grid__item--fluid m-grid m-grid--center m-grid--hor m-grid__item--order-tablet-and-mobile-1 m-login__content m-grid-item--center"
        :style="'background: url('+cdnURL+'/img/bg/bg-login.jpg) no-repeat center center / COVER'"
      >
        <div
          id="login-form-container"
          class="m-grid__item text-center p-4"
        >
          <router-link
            to="/"
          >
            <img
              alt="thinkSPAIN"
              :src="cdnURL+'/img/logos/white.png'"
              width="250px"
            >
            <p class="m-login__msg mb-2">
              {{ $t('app.name') }}
            </p>
          </router-link>
          <div
            id="language-picker"
            class="p-2"
          >
            <button
              type="button"
              :class="{'btn p-0 d-flex mr-2':true,'active':isActiveLanguage('en')}"
              :title="$t('lang.en')"
              @click="setLocale('en')"
            >
              {{ $t('lang.en') }}
            </button>
            <button
              type="button"
              :class="{'btn p-0 d-flex':true,'active':isActiveLanguage('es')}"
              :title="$t('lang.es')"
              @click="setLocale('es')"
            >
              {{ $t('lang.es') }}
            </button>
          </div>
          <form
            class="m-login__form m-form"
            style="width: 400px; max-width: 100%;"
            @submit.prevent="resetPassword"
          >
            <div v-if="!showSuccessMsg">
              <div :class="{'form-group m-form__group pb-0 mt-3': true,'has-success': hasClientID}">
                <input
                  v-model="clientID"
                  class="form-control m-input"
                  type="text"
                  :placeholder="$t('Login.login')"
                  autocomplete="off"
                  required
                  :disabled="loading"
                >
              </div>
              <div :class="{'form-group m-form__group mt-3 mb-2 pb-0 pt-0': true, 'has-success': passwordIsOK, 'has-error': hasProvidedPassword && !passwordsMatch}">
                <input
                  v-model="password"
                  class="form-control m-input m-login__form-input--last"
                  :type="passwordInputType"
                  :placeholder="$t('Login.password')"
                  autocomplete="off"
                  required
                  :disabled="loading"
                >
                <input
                  v-model="passwordConfirmed"
                  class="form-control m-input m-login__form-input--last mt-2"
                  :type="passwordInputType"
                  :placeholder="$t('Login.confirmPassword')"
                  autocomplete="off"
                  required
                  :disabled="loading"
                >
                <p
                  v-if="hasProvidedPassword && !passwordsMatch"
                  class="text-white font-weight-bold mt-1 mb-0 text-left"
                >
                  {{ $t( 'error.server.ErrPasswordsDontMatch' ) }}
                </p>
                <p
                  v-if="hasProvidedPassword && !passwordMeetsRequirements"
                  class="text-white font-weight-bold mt-1 mb-0 text-left"
                >
                  {{ $t( 'error.server.ErrPasswordDoesNotMeetRequirements' ) }}
                </p>
              </div>
              <button
                v-if="hasProvidedPassword"
                id="btn-password-toggle"
                class="btn btn-link p-0 text-white text-decoration-none d-flex align-items-center mt-1"
                type="button"
                @click="togglePassword"
              >
                <template v-if="passwordInputType === 'password'">
                  <i class="la la-eye mr-2" />
                  {{ $t( 'Login.showPassword' ) }}
                </template>
                <template v-else>
                  <i class="la la-eye-slash mr-2" />
                  {{ $t( 'Login.hidePassword' ) }}
                </template>
              </button>
              <div class="m-login__form-action mt-4">
                <button
                  id="m_login_signin_submit"
                  type="submit"
                  class="btn btn-focus m-btn m-btn--pill m-btn--custom m-btn--air w-100 font-weight-bold"
                  :disabled="loading || !canSubmit"
                >
                  {{ $t(submitTranslationKey) }}
                </button>
              </div>
            </div>
            <template v-if="showSuccessMsg">
              <div class="alert alert-light text-primary font-weight-bold mt-4">
                {{ $t( successMessageKey ) }}
              </div>
              <router-link
                to="/"
                class="btn btn-link mt-2 font-weight-bold text-white"
              >
                <i class="la la-chevron-left" />
                {{ $t('Login.backToLogin') }}
              </router-link>
            </template>
          </form>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { onBeforeOpenSwal, clearAuthCookies } from '../../functions.ts';
import { adminauthapiwithoutrefresh } from '../../api-clients/admin-auth-api.js';
import Cookie from 'js-cookie';
import { validatePassword } from '../../common/auth.js';

export default {
    name: 'PasswordReset',
    data() {
        return {
            cdnURL: import.meta.env.TWC_CDN_URL,
            clientID: '',
            password: '',
            passwordConfirmed: '',
            showSuccessMsg: false,
            loading: false,
            passwordInputType: 'password',
        };
    },
    computed: {
        hasClientID() {
            return !!this.clientID;
        },
        passwordsMatch() {
            return this.hasProvidedPassword && this.password === this.passwordConfirmed;
        },
        hasProvidedPassword() {
            return !!this.password || !!this.passwordConfirmed;
        },
        canSubmit() {
            return this.passwordIsOK;
        },
        passwordMeetsRequirements() {
            return this.hasProvidedPassword && this.passwordsMatch && validatePassword( this.password );
        },
        passwordIsOK() {
            return this.hasProvidedPassword && this.passwordsMatch && this.passwordMeetsRequirements;
        },
        isSetPasswordFlow() {
            const metaMode = this.$route.meta && this.$route.meta.mode;
            return metaMode === 'set' || this.$route.name === 'SetPassword';
        },
        submitTranslationKey() {
            return this.isSetPasswordFlow ? 'Login.setPassword' : 'Login.resetPassword';
        },
        successMessageKey() {
            return this.isSetPasswordFlow ? 'Login.setPasswordSuccessMsg' : 'Login.resetPasswordSuccessMsg';
        },
    },
    mounted() {
        clearAuthCookies();

        const query = this.$route.query || {};
        const params = this.$route.params || {};

        const clientIDFromQuery = typeof query.clientID === 'string' ? query.clientID : null;
        const clientIDFromParams = typeof params.clientID === 'string' ? params.clientID : null;

        const initialClientID = clientIDFromQuery || clientIDFromParams;

        if ( initialClientID ) {
            this.clientID = initialClientID;
        }
    },
    methods: {
        async resetPassword() {
            this.loading = true;

            mApp.block( 'body', { message: this.$t( 'common.LoadingDataPleaseWait' ) } );

            const endpoint = '/client/auth/reset';
            const localeLang = this.$i18n.locale === 'en' ? 'en' : 'es';

            const res = await adminauthapiwithoutrefresh.post(
                endpoint,
                {
                    token: this.$route.params.token,
                    clientID: this.clientID,
                    password: this.password,
                    lang: localeLang,
                },
                {
                    headers: {
                        'Accept-Language': localeLang,
                    },
                },
            );

            if ( res.status !== 200 ) {
                mApp.unblock( 'body' );
                this.loading = false;

                let codeTerm = 'error.server.ErrUnknown';

                if ( res.data && res.data.code ) {
                    codeTerm = `error.server.${res.data.code}`;
                }

                swal.fire( {
                    title: this.$t( 'error.AnErrorOccurred' ),
                    text: this.$t( codeTerm ),
                    type: 'error',
                    confirmButtonClass: 'btn btn-brand m-btn m-btn--wide',
                    onBeforeOpen: () => {
                        onBeforeOpenSwal();
                    },
                } ).then( () => {
                    if ( res.data && res.data.code === 'ErrPasswordRecoveryTokenNotFound' ) {
                        this.$router.replace( {
                            path: '/',
                        } );
                    }
                } );
                return;
            }

            window.setTimeout( () => {
                this.$router.replace( {
                    path: '/',
                } );
            }, 5000 );

            this.showSuccessMsg = true;

            mApp.unblock( 'body' );

            this.loading = false;
        },
        togglePassword() {
            if ( this.passwordInputType === 'text' ) {
                this.passwordInputType = 'password';
            } else {
                this.passwordInputType = 'text';
            }
        },
        setLocale( locale ) {
            Cookie.set( 'locale', locale, { expires: 14,
                sameSite: 'Strict' } );
            this.$i18n.locale = locale;
        },
        isActiveLanguage( codeLang ) {
            return this.$i18n.locale === codeLang;
        },
    },
};
</script>
<style lang="scss">
  #forgot-details-text a {
      text-decoration: underline;
  }

  #login-form-container {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    backdrop-filter: blur(10px);

    @media screen and (max-width: 575px) {
      height: 100vh;
    }
  }

  #language-picker {
    display: flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 20px;
    border-radius: 50px;
    width: fit-content;
    margin: 0 auto;

    button {
      position: relative;
      color: #fff;
      font-weight: 500;

      &:hover,
      &.active {
        text-decoration: underline;
      }
    }
  }

  .form-group {
    input {
      border-top: none;
      border-bottom: none;
      border-right: none;

      &:focus {
        border-left: none;
      }
    }

     &.has-success {
      input {
        border-left: 10px solid #34bfa3 !important;
      }
    }

     &.has-error {
      input {
        border-left: 10px solid #da4d51 !important;
      }
    }
  }
</style>
